import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import PropTypes from 'prop-types';
import Map from './Map';

class MapWrapper extends Component{
    state = {
        displayMap: false,
    };
    handleButtonClick = (event) => {
        this.setState({displayMap: true});
    };
    render(){
        return(
            <React.Fragment>
                { !this.state.displayMap &&
                    <Button
                        onClick={this.handleButtonClick}
                        color="primary"
                    >
                        <EyeIcon/>
                        View Map
                    </Button>
                }
                { this.state.displayMap &&
                    <Map
                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${
                            process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                            }&v=3.exp&libraries=geometry,drawing,places`}
                        loadingElement={<div />}
                        containerElement={<div style={{ height: '350px' }} />}
                        mapElement={<div id="googleMap" style={{ height: '100%' }} />}
                        draggable={this.props.draggable}
                        onMarkerChange={this.props.onMarkerChange}
                        markers={this.props.markers}
                    />
                }
            </React.Fragment>
        );
    }
}

MapWrapper.propTypes = {
    draggable: PropTypes.bool,
    onMarkerChange: PropTypes.func.isRequired,
    markers: PropTypes.arrayOf(PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        ordinal: PropTypes.number,
        isCurrentProject: PropTypes.bool
    })),
};

MapWrapper.defaultProps = {
    latitude: 0,
    longitude: 0,
    draggable: false,
    markers: []
};

export default MapWrapper;
